// Task State Helper Utilities
// Pure functions for task state transformations

/**
 * Generates a unique client-side ID that doesn't depend on task.id
 * @returns {string} - Unique client-side ID
 */
export function generateClientSideId() {
  return `client_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Adds _reactKey to tasks that don't have one
 * @param {Array} tasks - Array of tasks
 * @returns {Array} - Tasks with _reactKey added
 */
export function ensureTasksHaveReactKeys(tasks) {
  return tasks.map(task => ({
    ...task,
    _reactKey: task._reactKey || generateClientSideId()
  }));
}

/**
 * Creates a deep copy of tasks array
 * @param {Array} tasks - Array of tasks
 * @returns {Array} - Deep copy of tasks
 */
export function deepCopyTasks(tasks) {
  return JSON.parse(JSON.stringify(tasks));
}

/**
 * Updates a task in the tasks array
 * @param {Array} tasks - Array of tasks
 * @param {string} taskId - Task ID to update
 * @param {Object} updates - Updates to apply
 * @returns {Array} - Updated tasks array
 */
export function updateTaskInArray(tasks, taskId, updates) {
  return tasks.map(task => 
    task.id === taskId ? { ...task, ...updates } : task
  );
}

/**
 * Removes a task from the tasks array
 * @param {Array} tasks - Array of tasks
 * @param {string} taskId - Task ID to remove
 * @returns {Array} - Tasks array with task removed
 */
export function removeTaskFromArray(tasks, taskId) {
  return tasks.filter(task => task.id !== taskId);
}

/**
 * Adds a task to the tasks array
 * @param {Array} tasks - Array of tasks
 * @param {Object} newTask - New task to add
 * @returns {Array} - Tasks array with new task added
 */
export function addTaskToArray(tasks, newTask) {
  return [...tasks, newTask];
}
